/* Display only: retain the verified localization context through cart section updates.
 * A native destination change reloads the document and establishes a new context.
 * No prices, cart data, tax calculations, or discount rules are changed here.
 */
(() => {
  const drawer = document.querySelector('cart-drawer[data-yt-tax-mode]');
  if (!drawer || drawer.dataset.ytFiscalBound === 'true') return;
  drawer.dataset.ytFiscalBound = 'true';
  const context = { ...drawer.dataset };
  const isHT = context.ytTaxMode === 'HT';
  const unitLabel = isHT ? context.ytUnitHt : context.ytUnitTtc;
  const totalLabel = isHT ? context.ytTotalHt : context.ytTotalTtc;
  const applyLabels = () => {
    drawer.querySelectorAll('.cart-drawer-item-price-tax').forEach((label) => {
      if (label.textContent !== unitLabel) label.textContent = unitLabel;
    });
    drawer.querySelectorAll('[data-yt-fiscal-total]').forEach((label) => {
      if (label.textContent !== totalLabel) label.textContent = totalLabel;
    });
    const totalRow = drawer.querySelector('.yt-cart-summary__row--total');
    const note = drawer.querySelector('.yt-cart-summary__fiscal-note');
    if (isHT && totalRow && !note) {
      const newNote = document.createElement('small');
      newNote.className = 'caption-large yt-cart-summary__fiscal-note';
      newNote.style.cssText = 'display:block;border-top:1px solid rgba(0,0,0,.15);margin-top:8px;padding-top:8px;font-size:11px;line-height:1.4;';
      newNote.textContent = context.ytOverseasNote;
      totalRow.after(newNote);
    } else if (!isHT && note) {
      note.remove();
    }
  };
  new MutationObserver(applyLabels).observe(drawer, { childList: true, subtree: true });
  applyLabels();
})();
